import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-6 px-4 text-center" data-id="element-112">
      <div className="max-w-4xl mx-auto" data-id="element-113">
        <p className="font-bold text-slate-300 mb-2" data-id="element-114">PATITAS EMPRENDEDORAS™</p>
        <p className="text-sm" data-id="element-115">© 2026 — Todos los derechos reservados.</p>
        <p className="text-xs mt-6 opacity-50 max-w-2xl mx-auto" data-id="element-116">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}